// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0_@swc+core@1.7.1_@swc+helpers@0.5.5__/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0_@swc+core@1.7.1_@swc+helpers@0.5.5__/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KVssCohrfqjQ8NdHoCwb{display:flex;flex-direction:column;align-items:center;flex:1;width:100%}.KVssCohrfqjQ8NdHoCwb.JuF8FTISn4DbEcnccpfY{justify-content:center}`, "",{"version":3,"sources":["webpack://./src/domains/Shell/MainContent/MainContent.module.scss"],"names":[],"mappings":"AAEA,sBACE,YAAA,CACA,qBAAA,CACA,kBAAA,CACA,MAAA,CACA,UAAA,CAEA,2CACE,sBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContent": `KVssCohrfqjQ8NdHoCwb`,
	"mainContentCenter": `JuF8FTISn4DbEcnccpfY`
};
export default ___CSS_LOADER_EXPORT___;
